module.exports = __webpack_public_path__ + "static/media/16UNODC32.dd254b1b.jpg";